"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TaxonomySystemAttributes = /** @class */ (function () {
    function TaxonomySystemAttributes(data) {
        Object.assign(this, data);
    }
    return TaxonomySystemAttributes;
}());
exports.TaxonomySystemAttributes = TaxonomySystemAttributes;
//# sourceMappingURL=taxonomy-system-attributes.class.js.map